import _ from 'lodash';
import { makeCell } from './gridUtill';
let fields = [];
let columns = [];
const data = [
  {
    field: 'code',
    alias: '자재코드',
  },
  {
    field: 'rmav',
    alias: '원료약어',
  },
  {
    field: 'chemical_name',
    alias: '화학물질명',
  },
  {
    field: 'common_name',
    alias: '관용명 및 이명',
  },
  {
    field: 'cas_no',
    alias: 'CAS NO',
  },
  {
    field: 'mw',
    alias: '분자량',
  },
  {
    field: 'toxic_subs_yn',
    alias: '유독물질유무',
  },
  {
    field: 'toxic_no',
    alias: '유독물질번호',
  },
  {
    field: 'new_subs_yn',
    alias: '신규물질여부',
  },
  {
    field: 'gc_analy_yn',
    alias: 'GC분석가능여부',
  },
  {
    field: 'init_boiling_p',
    alias: '초기끓는점',
  },
  {
    field: 'ex_subs',
    alias: '기존물질',
  },
  {
    field: 'human_acute_threshold',
    alias: '인체급성유해성물질 법정기준함량(wt%)',
  },
  {
    field: 'human_chronic_threshold',
    alias: '인체만성유해성물질 법정기준함량(wt%)',
  },
  {
    field: 'eco_threshold',
    alias: '생태유해성물질 법정기준함량(wt%)',
  },
  {
    field: 'permitted_subs_yn',
    alias: '허가물질(Y/N)',
  },
  {
    field: 'restricted_subs_yn',
    alias: '제한물질(Y/N)',
  },
  {
    field: 'accident_prep_no',
    alias: '사고대비물질 번호',
  },
  {
    field: 'accident_prep_legal',
    alias: '사고대비물질 함유기준(%)',
  },
  {
    field: 'priority_mgmt_subs',
    alias: '중점관리물질',
  },
  {
    field: 'registered_existing_chem_no',
    alias: '등록대상 기존화학물질(번호)',
  },
  {
    field: 'prohibited_subs_yn',
    alias: '금지물질(Y/N)',
  },
  {
    field: 'permission_target_yn',
    alias: '허가대상물질(Y/N)',
  },
  {
    field: 'managed_hazard_subs_yn',
    alias: '관리대상 유해물질(Y/N)',
  },
  {
    field: 'work_env_measure_cycle',
    alias: '작업환경측정 대상 유해인자 주기',
  },
  {
    field: 'special_health_check_cycle',
    alias: '특수건강진단 대상 유해인자 주기',
  },
  {
    field: 'exposure_std_subs_yn',
    alias: '노출기준 설정물질(Y/N)',
  },
  {
    field: 'allowed_threshold_maintain_yn',
    alias: '허용기준 이하 유지 대상 유해인자(Y/N)',
  },
  {
    field: 'psm_target_yn',
    alias: '공정안전보고서(PSM) 제출 대상(Y/N)',
  },
  {
    field: 'trade_secret_excluded_yn',
    alias: '영업비밀 인정제외 물질(Y/N)',
  },
  {
    field: 'dangerous_goods_fire_agency',
    alias: '위험물안전관리법(소방청) 분류',
  },
  {
    field: 'dangerous_goods_kosha',
    alias: '위험물안전관리법(안전보건공단) 분류+지정수량',
  },
  {
    field: 'high_volume_chem_yn',
    alias: '대량생산화학물질(Y/N)',
  },
  {
    field: 'eu_reach_svhc',
    alias: 'EU REACH SVHC 후보물질',
  },
  {
    field: 'ec_no',
    alias: 'EC No.',
  },
  {
    field: 'special_note',
    alias: '특이사항',
  },
];

_.each(data, function (o) {
  o.indexExclusive = true;
  makeCell(1, [o], fields, columns);
});

// Y/N 드롭다운(not null, default 'N') 적용 대상 컬럼
const ynFields = ['toxic_subs_yn', 'new_subs_yn', 'permitted_subs_yn', 'restricted_subs_yn', 'prohibited_subs_yn', 'permission_target_yn', 'managed_hazard_subs_yn', 'exposure_std_subs_yn', 'allowed_threshold_maintain_yn', 'psm_target_yn', 'trade_secret_excluded_yn', 'high_volume_chem_yn'];

// 규제 해당 여부 Y/N 컬럼: 표시할 때 N 은 빈칸으로(값은 'N' 유지) → 해당(Y) 행만 눈에 잘 띄게.
// 편집 드롭다운의 N 도 빈 항목으로 보이며 선택 시 값은 'N'. (유독물질유무·신규물질여부는 대상 아님)
const blankNFields = ['permitted_subs_yn', 'restricted_subs_yn', 'prohibited_subs_yn', 'permission_target_yn', 'managed_hazard_subs_yn', 'exposure_std_subs_yn', 'allowed_threshold_maintain_yn', 'psm_target_yn', 'trade_secret_excluded_yn', 'high_volume_chem_yn'];

// 주기 드롭다운 옵션 (필드별로 다름)
const cycleOptionsMap = {
  work_env_measure_cycle: ['해당없음', '6개월'],
  special_health_check_cycle: ['해당없음', '6개월', '12개월', '24개월'],
};
const cycleFields = _.keys(cycleOptionsMap);

_.each(columns, col => {
  if (_.includes(ynFields, col.key)) {
    col.editor = {
      type: 'dropdown',
      textReadOnly: true,
      domainOnly: true,
      dropDownWhenClick: true,
    };
    col.labels = ['Y', 'N'];
    col.values = ['Y', 'N'];
    if (_.includes(blankNFields, col.key)) {
      // 규제 해당여부 컬럼: 표시만 N→빈칸(값·편집 드롭다운은 Y/N 유지) → Y 행만 눈에 띄게.
      // lookupDisplay(값→라벨) 와 경쟁하지 않도록 끄고, 셀 표시는 displayCallback 이 단독 담당.
      col.lookupDisplay = false;
      col.displayCallback = function (grid, index, value) {
        return value === 'Y' ? 'Y' : '';
      };
    } else {
      col.lookupDisplay = true;
    }
  } else if (col.key === 'gc_analy_yn') {
    // GC분석가능여부: Y=분석가능(정상/기본), N=분석불가(특이). 다른 Y/N 과 반대로 특이케이스(N)만 표기, Y 는 빈칸.
    // ※ ynFields 에는 넣지 않음(추가/편집 폼의 기본값 'Y' 로직 보존) — 그리드 표시/편집만 여기서 설정.
    col.editor = {
      type: 'dropdown',
      textReadOnly: true,
      domainOnly: true,
      dropDownWhenClick: true,
    };
    col.labels = ['Y', 'N'];
    col.values = ['Y', 'N'];
    col.lookupDisplay = false;
    col.displayCallback = function (grid, index, value) {
      return value === 'N' ? 'N' : '';
    };
  } else if (_.includes(cycleFields, col.key)) {
    const opts = cycleOptionsMap[col.key];
    col.editor = {
      type: 'dropdown',
      textReadOnly: true,
      domainOnly: true,
      dropDownWhenClick: true,
    };
    col.lookupDisplay = true;
    col.labels = opts;
    col.values = opts;
  }
});

export { fields, columns, ynFields, cycleFields, cycleOptionsMap };
